import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.css';

const Icon = ({ className, icon, title }) => {
  const iconClasses = cx(
    {
      [styles.icon]: true,
    },
    className
  );

  return (
    <svg className={iconClasses} role="img" viewBox={icon.viewBox}>
      {title && <title>{title}</title>}
      {icon.data}
    </svg>
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.object.isRequired,
  title: PropTypes.string,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/index.js